import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OffersOfApplication, Result } from '../type/result_type';

export type KreditcenterTab = 'angebote' | 'active';

@Injectable({
  providedIn: 'root',
})
export class OfferDataUtilsService {
  // Shared state for mobile interest explanation across all pages
  private _showMobInterestExplanation = new BehaviorSubject<any>([]);

  // Shared state for eternal offers data across eternal pages
  private _eternalOffersData$ = new BehaviorSubject<Result | null>(null);

  private _kreditcenterTab: KreditcenterTab = 'angebote';

  readonly eternalOffersDataObserv$ = this._eternalOffersData$.asObservable();

  set showMobInterestExplanation(value: any) {
    this._showMobInterestExplanation.next(value);
  }

  get showMobInterestExplanation() {
    return this._showMobInterestExplanation.getValue();
  }

  updateEternalOffersData(data: Result): void {
    this._eternalOffersData$.next(data);
  }

  setKreditcenterTab(tab: KreditcenterTab): void {
    this._kreditcenterTab = tab;
  }

  getKreditcenterTab(): KreditcenterTab {
    return this._kreditcenterTab;
  }

  sortNoOffersData(noOffers: OffersOfApplication[]): OffersOfApplication[] {
    if (!noOffers) return [];

    const inProgressCards = noOffers.filter(
      (card) => card.state === 'IN_PROGRESS'
    );
    const otherCards = noOffers.filter(
      (card) => card.state !== 'IN_PROGRESS'
    );

    return [...inProgressCards, ...otherCards];
  }

  getSingleOfferById(
    offers: OffersOfApplication[] | null | undefined,
    offerId: string
  ): OffersOfApplication | undefined {
    return offers?.find((offer) => offer.id === offerId);
  }

  getEternalOffersDataSnapshot(): Result | null {
    return this._eternalOffersData$.getValue();
  }

  findOfferById(
    data: Result | null | undefined,
    offerId: string,
  ): OffersOfApplication | undefined {
    if (!data || !offerId) {
      return undefined;
    }

    return (
      this.getSingleOfferById(
        data.offersOfApplicationInClosingProcess,
        offerId,
      ) ?? this.getSingleOfferById(data.offersOfApplication, offerId)
    );
  }
}
